import { render, staticRenderFns } from "./backToParent.vue?vue&type=template&id=771e771c&scoped=true&"
import script from "./backToParent.vue?vue&type=script&lang=ts&"
export * from "./backToParent.vue?vue&type=script&lang=ts&"
import style0 from "./backToParent.vue?vue&type=style&index=0&id=771e771c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e771c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('771e771c', component.options)
    } else {
      api.reload('771e771c', component.options)
    }
    module.hot.accept("./backToParent.vue?vue&type=template&id=771e771c&scoped=true&", function () {
      api.rerender('771e771c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/backToParent.vue"
export default component.exports